import Link from "next/link";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import { cn } from "src/lib/utils";

interface HoveredLinkProps {
    children: React.ReactNode;
    className?: string;
    href: string;
    visible?: boolean;
    noLink?: boolean;
}

export default function HoveredLink ({ children, className, href, visible = true, noLink = false }: HoveredLinkProps) {
    const content = (
        <Button variant="hover" size="none" className={cn("flex justify-start items-center gap-1 w-full", className)}>
            {children} <ArrowRight className={cn("size-4 invisible group-hover:visible group-hover:translate-x-1 transition-all duration-200", !visible && "invisible")} />
        </Button>
    );

    if (noLink) {
        return content;
    }

    return (
        <Link href={href}>
            {content}
        </Link>
    );
};
  